import { Navigate, Outlet } from 'react-router-dom';

export const PrivateRoutes = () => {
  const token: string | null = localStorage.getItem('token');
  return token ? <Outlet /> : <Navigate to="/login" />;
};
